export default __webpack_public_path__ + "static/media/wallet-coin.93c2803b.png";